import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { withGuard } from 'ui-components/components/with-guard';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { useBinaryState } from '../../../../../hooks/use-binary-state';
import { SimpleModal } from '../../../../simple-modal';
import { deleteImportMapping } from '../../../data/api';
import { MappingTemplate } from '../../../data/types/mapping-template';
import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.css';

export const ConfirmDeleteMappingModal = withGuard(({ onClose, importTemplate }) => {
  const { deleteMappingTemplate, setMapping } = useImportContext();
  const [isDeleteLoading, startLoading, stopLoading] = useBinaryState();
  const onDelete = () => {
    startLoading();
    deleteImportMapping(importTemplate.mappingId)
      .then(() => {
        deleteMappingTemplate(importTemplate.mappingId);
        setMapping({});
        onClose();
      })
      .catch(() => {
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_ERROR,
          title: <FormattedMessage {...messages.deleteTemplateErrorTitle} />,
          content: <FormattedMessage {...messages.deleteTemplateErrorMessage} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      })
      .finally(stopLoading);
  };
  return (
    <SimpleModal
      actionMessage={messages.confirmDeleteModalDeleteButton}
      cancelMessage={messages.confirmDeleteModalCancelButton}
      className={styles['confirm-modal-body']}
      headerMessage={messages.confirmDeleteModalTitle}
      isActionDisabled={isDeleteLoading}
      onAction={onDelete}
      onCancel={onClose}
      onClose={onClose}
      size='small'
    >
      {isDeleteLoading ? (
        <LoadingIndicator className={styles['loading-indicator']} />
      ) : (
        <FormattedMessage
          {...messages.confirmDeleteModalBodyMessage}
          values={{
            mappingName: importTemplate.name,
          }}
        />
      )}
    </SimpleModal>
  );
});

ConfirmDeleteMappingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  importTemplate: MappingTemplate.isRequired,
};
